import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=4d2abb75&"
import script from "./StatusChip.vue?vue&type=script&lang=js&"
export * from "./StatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports